import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Tabs, Tab, Box } from '@mui/material';
import Layout from '../../components/Layout';
import SubscriptionCodesScreen from './SubscriptionCodesScreen';
import UnusedCodesScreen from './UnusedCodesScreen';
import { useTranslation } from 'react-i18next';

const SubscriptionCodesPage: React.FC = observer(() => {
  const { t } = useTranslation();
  const [tab, setTab] = useState(0);

  return (
    <Layout title={t('subscription_codes.title')}>
      <Box px={3} pt={2}>
        <Tabs value={tab} onChange={(_e, v) => setTab(v)}>
          <Tab label={t('subscription_codes.generate_tab')} />
          <Tab label={t('subscription_codes.unused_tab')} />
        </Tabs>
      </Box>
      <Box>
        {tab === 0 && <SubscriptionCodesScreen standalone={false} />}
        {tab === 1 && <UnusedCodesScreen standalone={false} />}
      </Box>
    </Layout>
  );
});

export default SubscriptionCodesPage;
